import { render, staticRenderFns } from "./CustomerListView.vue?vue&type=template&id=24e001aa&scoped=true"
import script from "./CustomerListView.vue?vue&type=script&lang=js"
export * from "./CustomerListView.vue?vue&type=script&lang=js"
import style0 from "./CustomerListView.vue?vue&type=style&index=0&id=24e001aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e001aa",
  null
  
)

export default component.exports